import { withI18nPlaceholders } from '@change-corgi/core/react/i18n';

import { TemplateContainer } from './containers/Template';
import CONTENT_PLACEHOLDERS from './landing-content.i18n.yml';

export const Template = withI18nPlaceholders(CONTENT_PLACEHOLDERS, TemplateContainer);
